export default __webpack_public_path__ + "static/media/whiteArrow.d434d8c1.svg";